import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface GenSingleImageLogoModel extends BaseModel {
  variables?: { [key: string]: string } | GenSingleImageLogoVariables;
}

export interface GenSingleImageLogoVariables {
  /** Subdirectory name of the selected brand logo, '' when none is picked. */
  Logo: string;
}

export class GenSingleImageLogoInitVariables implements GenSingleImageLogoVariables {
  Logo = '';
}

export class GenSingleImageLogoInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new GenSingleImageLogoInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
